import * as api from '../../api/bitacora-client';
import { 
    GET_CONFIG_FORM,
    GET_INSTANCIAS_EVENTO,
    GET_EVENTOS_BITACORA,
    GET_TIPOS_EVENTO,
    POST_REGISTRAR_BITACORA,
    CLEAR_CASOS_BANDEJA
} from '../types';


export const configuracionFormAction = (query) => ({
    type: GET_CONFIG_FORM,
    payload: api.getConfiguracionForm(query)
});
export const obtenerInstanciasEventoAction = (query) => ({
    type: GET_INSTANCIAS_EVENTO,
    payload: api.getConceptos(query)
});
export const obtenerEventosBitacoraAction = (query) => ({
    type: GET_EVENTOS_BITACORA,
    payload: api.getEventosBitacora(query)
});
export const obtenerTiposEventoAction = (query) => ({
    type: GET_TIPOS_EVENTO,
    payload: api.getConceptos(query)
});
export const registrarBitacoraAction = (bitacora) => ({
    type: POST_REGISTRAR_BITACORA,
    payload: api.postRegistraBitacora(bitacora)
})
export const limpiarCasosBandeja = () => ({
    type: CLEAR_CASOS_BANDEJA,
    payload: { casos: [], query: null }
});